<!-- Contract Sidebar -->
<p-drawer [visible]="showPaymentStatusSidebar()" [showCloseIcon]="false" position="right" [blockScroll]="false" [dismissible]="false"
  styleClass="w-full payment-sidebar" [dismissible]="false" [closeOnEscape]="false" appendTo="body" [modal]="true"
  >

  <ng-template #header>
    @if (showLoader) {
      <div class="absolute top-0 left-0 w-full">
        <p-progressBar [mode]="progressBarMode" [style]="{'height': '6px'}" />
      </div>
    }

    <!-- Header -->
    <div
      class="-mt-1 py-2 px-3 w-full md:p-3 border-bottom-1 border-300 relative flex align-items-center justify-content-between">

      <h4 class="flex align-items-center mb-0 mr-3 font-normal">
        <i class="fa fa-money-bill text-400 mr-3"></i>
        @if (shouldShowChargePaymentFailure) {
          <span class="text-base">{{ 'POS_DEVICE.PAYMENT_FAILED' | translate }}</span>
        } @else {
          <span class="text-base">{{ 'POS.PAYMENT_SUCCESS.PAYMENT_INITATED' | translate }}</span>
        }
      </h4>

      <!-- Close Icon -->
      <i class="fa fa-times text-xl text-600 cursor-pointer absolute right-0 top-0 mt-2 md:mt-3 mr-3"
      (click)="setHidePaymentSideBar()"></i>
      <!-- Close Icon -->

    </div>
    <!-- Header -->
  </ng-template>
  <ng-template #content>
    @if (!ispayment()) {
      <div>
        <!-- Freeze Order Details -->
        @if (freezeOrderData$ | async; as freezeOrder) {
          <div class="py-2 px-3 md:p-3">
            @if ((showSkeleton$ | async) === false && freezeOrder.freeze_type) {
              <span
                class="bg-blue-50 px-2 py-1 border-round text-primary text-xs border-primary border-1 inline-block mt-1 md:mt-0">
                {{ freezeOrder.freeze_type === 'PaidFreeze' ? 'Paid Freeze' : 'Free Freeze' }}
              </span>
            }
            @if ((showSkeleton$ | async)) {
              <p-skeleton width="100%" height="1.35rem" styleClass="mb-0 mt-2 md:mb-1" />
            }
            
            <!-- Heading -->
            <div class="mt-2 md:mt-3">
              @if ((showSkeleton$ | async) === false) {
                <div>
                  <h3 class="text-base font-bold mb-2">Freeze Request #{{freezeOrder.frz_req_id}}</h3>
                  <p class="text-xs text-600 mb-2">{{freezeOrder.frz_req_reason_pri_lang}}</p>
                </div>
              }
              @if ((showSkeleton$ | async)) {
                <p-skeleton width="100%" height="1.35rem" styleClass="mb-0 mt-2 md:mb-1" />
              }
            </div>
            
            <!-- Freeze Details Grid -->
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 mt-3">
            @if ((showSkeleton$ | async) === false) {
              <div class="grid my-3 text-xs">
                <div class="col-6">
                  <span class="text-600">Client ID:</span>
                  <span class="font-semibold ml-2">{{freezeOrder.frz_req_clt_id}}</span>
                </div>
                <div class="col-6">
                  <span class="text-600">Subscription ID:</span>
                  <span class="font-semibold ml-2">{{freezeOrder.frz_req_clt_subs_id}}</span>
                </div>
                <div class="col-6 mt-2">
                  <span class="text-600">Start Date:</span>
                  <span class="font-semibold ml-2">{{freezeOrder.requested_start_date | date:'dd MMM yyyy'}}</span>
                </div>
                <div class="col-6 mt-2">
                  <span class="text-600">End Date:</span>
                  <span class="font-semibold ml-2">{{freezeOrder.requested_end_date | date:'dd MMM yyyy'}}</span>
                </div>
                <div class="col-6 mt-2">
                  <span class="text-600">Action Type:</span>
                  <span class="font-semibold ml-2">{{getFreezeActionTypeText(freezeOrder.frz_req_action_type)}}</span>
                </div>
                <div class="col-6 mt-2">
                  <span class="text-600">Status:</span>
                  <span class="font-semibold ml-2">{{getFreezeStatusText(freezeOrder.frz_req_status)}}</span>
                </div>
                @if (freezeOrder.freeze_type === 'PaidFreeze' && freezeOrder.frz_req_charge_amount_in_minor > 0) {
                  <div class="col-12 mt-2">
                    <span class="text-600">Charge Amount:</span>
                    <span class="font-semibold text-lg ml-2">{{freezeOrder.frz_req_charge_amount_in_minor | currencyformat}}</span>
                  </div>
                }
              </div>
            }
            @if ((showSkeleton$ | async)) {
              <p-skeleton width="100%" height="10rem" styleClass="mt-3" />
            }
            
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-4">
          </div>
        }
        
      <!-- Top Part - Subscription Details (shown when NOT freeze order) -->
      @if (subsData$ | async; as subscription) {
        @if (subscription.subscription_category) {
          <div class="py-2 px-3 md:p-3">
            @if ((showSkeleton$ | async) === false && subscription.subscription_category) {
              <span
                class="bg-blue-50 px-2 py-1 border-round text-primary text-xs border-primary border-1 inline-block mt-1 md:mt-0">
                {{'POS.PLANTYPE.' + subscription.subscription_category.toUpperCase() |translate }}
              </span>
            }
            @if ((showSkeleton$ | async)) {
              <p-skeleton width="100%" height="1.35rem" styleClass="mb-0 mt-2 md:mb-1" />
            }
            <!-- Heading -->
            <div class="flex justify-content-between mt-2 md:mt-3">
              @if ((showSkeleton$ | async) === false) {
                <div>
                  <h3 class="text-base font-bold mb-2">{{subscription.name_primary_language}}</h3>
                  <p class="text-xs text-600 mb-2 md:w-20rem">{{subscription.description_primary_language}}</p>
                </div>
              }
              @if ((showSkeleton$ | async)) {
                <p-skeleton width="100%" height="1.35rem" styleClass="mb-0 mt-2 md:mb-1" />
              }
              @if ((showSkeleton$ | async)) {
                <p-skeleton width="4rem" height="1.35rem" />
              }
            </div>
            <!-- Heading -->
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0">
            <!-- Row -->
            @if ((showSkeleton$ | async) === false) {
              <div class="mb-0 mt-2 md:mb-1 text-xs text-600"
                [innerHTML]="allServiceNameHtml(subscription)">
              </div>
            }
            <!-- Row -->
            @if ((showSkeleton$ | async)) {
              <p-skeleton width="100%" height="1.35rem" styleClass="mb-0 mt-2 md:mb-1" />
            }
            <!-- Features -->
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-2">
            @if ((showSkeleton$ | async) === false) {
              <div class="grid my-0 text-xs white-space-nowrap">
                @for (charge of subscription.charging_today?.signup_charges; track charge) {
                  <div class="col-12 sm:col-4 flex align-items-center">
                    <i class="fa fa-check-square text-xs text-500 mr-2"></i>
                    <span>{{charge.chrgmst_name_pri_lang}} + {{charge.chrgmst_net_cost_in_minor_curr | currencyformat}}</span>
                  </div>
                }
              </div>
            }
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-4">
            @if ((showSkeleton$ | async)) {
              <p-skeleton width="100%" height="1.35rem" styleClass="" />
            }
          </div>
        }
      }

      <!-- Top Part - Charge Order Details -->
      @if (chargeOrderData$ | async; as chargeOrder) {
        <div class="py-2 px-3 md:p-3">
          @if ((showSkeleton$ | async) === false) {
            <span class="bg-blue-50 px-2 py-1 border-round text-primary text-xs border-primary border-1 inline-block mt-1 md:mt-0">
              {{'POS.MEMBERSHIP_ADDON.CHARGE' | translate}}
            </span>
          }
          @if ((showSkeleton$ | async)) {
            <p-skeleton width="100%" height="1.35rem" styleClass="mb-0 mt-2 md:mb-1" />
          }

          <!-- Heading -->
          <div class="flex justify-content-between mt-2 md:mt-3">
            @if ((showSkeleton$ | async) === false) {
              <div>
                <h3 class="text-base font-bold mb-2">{{chargeOrder.billing_json?.invoice_billing_name}}</h3>
                <p class="text-xs text-600 mb-0">
                  {{'POS.PAYMENT_SUCCESS.ISSUE_DATE' | translate}}:
                  <span class="font-semibold">{{chargeOrder.billing_json?.issue_date | date:'dd MMM yyyy'}}</span>
                </p>
              </div>
            }
            @if ((showSkeleton$ | async) === false) {
              <div class="white-space-nowrap ml-3 text-right">
                <strong class="text-base">{{calculateChargeOrderTotal(chargeOrder) | currencyformat}}</strong>
                <i class="block text-600 text-xxs">{{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}</i>
              </div>
            }
            @if ((showSkeleton$ | async)) {
              <p-skeleton width="4rem" height="1.35rem" />
            }
          </div>
          <!-- Heading -->

          <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 mt-2">

          <!-- Charge Line Items -->
          @if ((showSkeleton$ | async) === false) {
            <div class="mt-2 mb-1">
              @for (charge of chargeOrder.billing_json?.order_charges; track charge.chrgmst_id) {
                <div class="flex align-items-center justify-content-between py-1 border-bottom-1 border-100">
                  <div class="flex align-items-center text-xs">
                    <i class="fa fa-check-square text-xs text-500 mr-2"></i>
                    <div>
                      <span class="font-medium text-900">{{charge.chrgmst_name_pri_lang}}</span>
                      @if (charge.chrgcategory_name_pri_lang) {
                        <span class="ml-2 text-xxs text-500 surface-100 px-1 border-round">{{charge.chrgcategory_name_pri_lang}}</span>
                      }
                      @if (charge.chrgmst_discount_amount_in_minor_curr > 0) {
                        <span class="ml-1 text-xxs text-red-400">
                          -{{'POS.MEMBERSHIP_ADDON.DISCOUNT' | translate}}
                        </span>
                      }
                    </div>
                  </div>
                  <div class="text-xs text-right ml-3">
                    <span class="font-semibold">{{charge.chrgmst_net_cost_in_minor_curr | currencyformat}}</span>
                    @if (charge.tax?.tax_line_items?.length) {
                      <span class="block text-600 text-xxs">
                        + {{getTaxTotalForCharge(charge) | currencyformat}} {{'POS.MEMBERSHIP_ADDON.TAX' | translate}}
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if ((showSkeleton$ | async)) {
            <p-skeleton width="100%" height="3rem" styleClass="mt-2" />
          }

          <!-- Status Badge -->
          @if ((showSkeleton$ | async) === false) {
            <div class="flex align-items-center justify-content-between mt-2 pt-1">
              <span class="text-xs text-600">{{'POS.PAYMENT_SUCCESS.STATUS' | translate}}:</span>
              <span class="text-xs font-semibold px-2 py-1 border-round"
                [ngClass]="{
                  'bg-green-50 text-green-600 border-1 border-green-300': chargeOrder.status === 'Successfull' || chargeOrder.status === 4,
                  'bg-orange-50 text-orange-600 border-1 border-orange-300': chargeOrder.status === 'Created' || chargeOrder.status === 1 || chargeOrder.status === 'Open' || chargeOrder.status === 2 || chargeOrder.status === 'AwaitingPayment' || chargeOrder.status === 3,
                  'bg-red-50 text-red-600 border-1 border-red-300': chargeOrder.status === 'Failed' || chargeOrder.status === 5 || chargeOrder.status === 'Expired' || chargeOrder.status === 6
                }">
                {{chargeOrder.status}}
              </span>
            </div>
          }

          <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-4">
        </div>
      }
      <!-- Top Part -->
      @if (shouldShowChargePaymentFailure) {
        <div class="-mt-2 px-3 md:px-3">
          <p-message severity="error" icon="fa fa-times-circle" aria-label="charge-payment-unsuccessful-message"
            data-testid="charge-payment-unsuccessful-message">
            {{ chargePaymentFailureMessage }}
          </p-message>
        </div>
        <div class="py-4 px-3 md:p-3 text-center">
          <i class="fa fa-times-circle text-red-500 text-6xl mb-3"></i>
          <h3 class="text-xl font-bold text-red-500 mb-2">{{ 'POS_DEVICE.PAYMENT_FAILED' | translate }}</h3>
          <p class="text-base text-700 m-0">{{ 'POS.PG_ERROR.UNSUCCESSFULLY' | translate }}</p>
        </div>
      } @else {
      <!-- Error Message -->
      <div class="-mt-5">
        <p-message severity="warn" icon="fa fa-info-circle" aria-label="payment-status-message">
          {{'POS.PAYMENT_SUCCESS.CLOSE_WINDOW_ANYTIME' | translate}}
          {{'POS.PAYMENT_SUCCESS.PAYMENT_RUN_BACKGROUND' | translate}}
        </p-message>
      </div>
      <!-- Error Message -->
      <!-- Mid Part -->
      <!-- Bottom Part -->
      <div class="py-2 px-3 md:p-3 surface-100 border-bottom-1 border-300">
        <div class="text-center mx-auto md:w-28rem">
          <h3 class="text-2xl mb-2">{{'POS.PAYMENT_SUCCESS.ALMOST_DONE' | translate}}</h3>
          <p class="mb-0 text-base text-700">{{'POS.PAYMENT_SUCCESS.GREATJOB' | translate}}</p>
        </div>
        <hr
          class="border-400 border-top-2 border-bottom-none border-left-none border-right-none w-5rem mt-3 mb-4 mx-auto">
          @if ((showSkeleton$ | async)) {
            <p-skeleton width="100%" height="10.35rem" styleClass="" />
          }
          <!-- Timeline -->
          <!-- Timeline -->
          @if (subscriptionSignUpStatus$ | async; as paymentStatus) {
            @if ((showSkeleton$ | async) === false) {
              <p-timeline [value]="paymentStatus"
                styleClass="payment-status md:w-28rem mt-5 md:ml-4">
                <ng-template pTemplate="marker" let-event>
                  @if (event.status === 'Done') {
                    <span
                      class="custom-marker h-2rem w-2rem border-circle bg-green-500 text-white flex align-items-center justify-content-center">
                      <i [ngClass]="event.icon"></i>
                    </span>
                  }
                  @if (event.status === 'Error') {
                    <span
                    class="custom-marker h-2rem w-2rem border-1 border-circle p-error flex align-items-center justify-content-center">{{event.step}}</span>
                  }
                  @if (event.status === 'Pending') {
                    <span class="flex align-items-center justify-content-center relative">
                      <i class="fa fa-spinner text-primary text-4xl absolute left-0 top-0"></i>
                      <span
                      class="custom-marker h-2rem w-2rem border-circle text-primary flex align-items-center justify-content-center text-sm">{{event.step}}</span>
                    </span>
                  }
                  @if (event.status === 'Not Done') {
                    <span
                      class="custom-marker h-2rem w-2rem border-circle border-2 text-300 border-300 flex align-items-center justify-content-center text-sm">
                      {{event.step}}
                    </span>
                  }
                </ng-template>
                <ng-template pTemplate="content" let-event>
                  <div class="mb-4">
                    <h4 class="text-sm font-bold mb-0" [ngClass]="event.status ==='Error' ? 'p-error' : '' ">
                    {{'POS.PAYMENT_SUCCESS.' + (event.title ? event.title.toUpperCase() : '') |translate }}</h4>
                    <p class="text-sm m-0" [ngClass]="event.status ==='Error' ? 'p-error' : 'text-600' ">
                    {{'POS.PAYMENT_SUCCESS.' + (event.text ? event.text.toUpperCase() : '') |translate }}</p>
                    @if (event.step === 1) {
                      <div>
                        <div class="text-sm text-600 m-0">{{'POS.PAYMENT_SUCCESS.WAIVER_LINK' | translate}}
                          @if (showSignUplink) {
                            <a class="text-primary break-word" [href]="bitlyLink" target="_blank">{{bitlyLink}}</a>
                          }
                        </div>
                        <div class="md:flex align-items-center my-2">
                          @if (showSignUplink) {
                            <div  class="md:mr-2">
                              <qr-code value={{bitlyLink}} size="100" errorCorrectionLevel="L" centerImageSrc="undefined"
                                centerImageSize="undefined" margin="4" />
                            </div>
                          }
                          @if ((showResendLink | async)) {
                            <div class="relative inline-block mt-3 md:mt-0">
                              <p-button styleClass="text-sm justify-content-between align-items-center p-0" pStyleClass="@next"
                                enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout"
                                [hideOnOutsideClick]="true">
                                <div class="flex align-items-center mr-3 p-2">
                                  <i class="fa fa-paperclip "></i><span
                                class="p-button-label ml-2">{{'POS.PAYMENT_SUCCESS.RESEND_LINK' | translate}}</span>
                              </div>
                              <div class="p-2 border-left-1 border-white">
                                <i class="fa fa-angle-down mt-1 ml-1"></i>
                              </div>
                            </p-button>
                            <div
                              class="hidden resend-dropdown hidden absolute left-0 w-full top-0 mt-6 z-1 surface-0 border-round border-1 border-300 py-2 text-sm">
                              <div (click)="ResendPaymentLink('Email')" class="px-3 py-2 hover:surface-200 cursor-pointer"
                                pStyleClass=".resend-dropdown" enterFromClass="hidden" enterActiveClass="scalein"
                                leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                              {{'POS.PAYMENT_SUCCESS.SEND_EMAIL_LINK' | translate}}</div>
                              <div (click)="ResendPaymentLink('WhatsApp')" class="px-3 py-2 hover:surface-200 cursor-pointer"
                                pStyleClass=".resend-dropdown" enterFromClass="hidden" enterActiveClass="scalein"
                                leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                              {{'SUBSCRIPTIONS.SEND_WHATSAPP_LINK' | translate}}</div>
                              <div (click)="ResendPaymentLink('Push')" class="px-3 py-2 hover:surface-200 cursor-pointer"
                                pStyleClass=".resend-dropdown" enterFromClass="hidden" enterActiveClass="scalein"
                                leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                              {{'SUBSCRIPTIONS.SEND_PUSH_NOTIFICATION_LINK' | translate}}</div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </ng-template>
            </p-timeline>
          }
        }
        <!-- Timeline -->
      </div>
      <!-- Bottom Part -->
      <!-- Add this where you want the refresh button to appear -->
      @if (showRefreshButton | async) {
        <div class="text-center mt-3">
          <p-button icon="pi pi-refresh"
            [label]="'POS.PAYMENT_SUCCESS.REFRESH_STATUS' | translate"
            (onClick)="refreshStatus()"
            styleClass="p-button-outlined"
            [loading]="refreshButtonLoader | async"
             />
        </div>
      }
      }
      <div class="text-center my-3">
        <p-button [label]="'POS.PAYMENT_SUCCESS.GO_TO_CLIENT_PROFILE' | translate" class="text-sm" styleClass="w-20rem" (click)="GoToCLientProfile('')" />
      </div>
    </div>
  }


  <!-- Content Wrapper -->
  @if (ispayment()) {
    <div class="fa fa-times text-xl ml-3 cursor-pointer"  (click)="setHidePaymentSideBar()"></div>
  }
  @if (ispayment()) {
    <div class="p-sidebar-content__wrapper text-center p-5">
      <h4 class="text-base md:text-2xl mb-7">{{'POS.PAYMENT_SUCCESS.PAYMENT_RECORDED_SUCCESULLY' | translate}}</h4>
      <img src="/assets/img/collect-dues-success-img.svg" alt="Collect Dues Success" />
      <button class="text-lg mt-6 w-full" type="button" (click)="GoToCLientProfile('transactions')" pButton pRipple [label]="'POS.PAYMENT_SUCCESS.GO_TO_CLIENT_PROFILE' | translate"></button>
    </div>
  }
  <!-- Content Wrapper -->
</ng-template>
</p-drawer>

<!-- Contract Sidebar -->
